
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import { PageAll, PagePageLayoutLinkedItemsItem } from 'api/graphql/generated';
import CardGrid from 'components/pages/contact/CardGrid';
import ContactPhoneEmail from 'components/pages/contact/ContactPhoneEmail';
import { Styles } from 'components/pages/contact/ContactStyles.bs';
import CCBanner from 'components/pages/contact/CustomerCareBanner';
import CustomerCareEnquiries from 'components/pages/contact/CustomerCareEnquiries';
import * as IndexStyles from 'components/pages/index/IndexStyles.bs';
import { NextPage } from 'next';
import resolver from 'utils/layoutResolver';

const compMap = (component: PagePageLayoutLinkedItemsItem, index: number) => {
  switch (component.__typename) {
    case 'CustomerCareBanner':
      return ['banner', <CCBanner bannerData={component} key={index} />];
    case 'CustomerCareCallUs':
      return ['callUs', <ContactPhoneEmail contactData={component} key={index} />];
    case 'AreaOfInterest':
      switch (component.importance.items[0]._system_.codename) {
        case 'high':
          return ['areaOfInterestHigh', <CardGrid block={component} key={index} />];
        case 'medium':
          return ['areaOfInterestMedium', <CustomerCareEnquiries block={component} key={index} />];
        default:
          return null;
      }
    default:
      return null;
  }
};

interface ContactProps {
  data: PageAll;
}

type compNames = 'banner' | 'callUs' | 'areaOfInterestHigh' | 'areaOfInterestMedium';

const Contact: NextPage<ContactProps> = ({ data }) => {
  const components = data?.items[0]?.pageLayout?.linkedItems?.items || [];

  const componentMap = components.map((component, index) => {
    return compMap(component, index);
  });

  const getComponentByName = (name: compNames) => {
    return componentMap.map(component => {
      if (component && component[0] === name) return component[1];
    });
  };

  return (
    <div className={Styles.rootContainer}>
      {getComponentByName('banner')}

      <div className={Styles.container}>
        {getComponentByName('areaOfInterestHigh')}
        {getComponentByName('areaOfInterestMedium')}
      </div>
      <div className={Styles.bottomContainer}>
        <div className={[IndexStyles.section, Styles.bottomContainerSection].join(' ')}>
          <div className={Styles.bottomInnerContainer}>{getComponentByName('callUs')}</div>
        </div>
      </div>
    </div>
  );
};

export const getServerSideProps = resolver;

export default Contact;
